import React from 'react';
import PropTypes from 'prop-types'
import Drawer from '../Common/Drawer/Drawer';
import InputText from '../Common/InputText';
import Button from '../Common/Button';
import './SubscriptionGoalDrawer.scss';

const SubscriptionGoalDrawer = (props) => {

    return (
        <Drawer isWide={false} className="subscription-goal-drawer" title='Edit Goal Group'
            onCancelClick={props.onCancel}
            cancelText="Close"
            >
                <InputText 
                    name="name"
                    label="Group Name"
                    value={props.goalGroup.name}
                    placeholder="Group Name"
                    onChange={(e) => props.onGoalGroupChange(props.goalGroup, e)}
                    type="text" maxLength={100} />  
                <hr />
                <div className="row goal">
                {
                    props.goalGroup.goals.map((goal, goalIndex) => {
                        return (<div key={goal.id} className="col-6">
                            <div className="goal-name">
                                <InputText name="name"
                                    label="Goal Name"
                                    value={goal.name}
                                    placeholder="Goal Name"
                                    onChange={(e) => props.onGoalChange(props.goalGroup.ordinal, goalIndex, e)}
                                    type="text" maxLength={100} />
                            </div>
                            <div className="goal-metrics">
                                <InputText name="darkGreenName"
                                    label="Metric 1 Name"
                                    value={goal.darkGreenName}
                                    placeholder="Metric 1 Name"
                                    onChange={(e) => props.onGoalChange(props.goalGroup.ordinal, goalIndex, e)}
                                    type="text" maxLength={100} />
                                <InputText name="mediumGreenName"
                                    label="Metric 2 Name"
                                    value={goal.mediumGreenName}
                                    placeholder="Metric 2 Name"
                                    onChange={(e) => props.onGoalChange(props.goalGroup.ordinal, goalIndex, e)}
                                    type="text" maxLength={100} />
                                <InputText name="lightGreenName"
                                    label="Metric 3 Name"
                                    value={goal.lightGreenName}
                                    placeholder="Metric 3 Name"
                                    onChange={(e) => props.onGoalChange(props.goalGroup.ordinal, goalIndex, e)}
                                    type="text" maxLength={100} />
                            </div>

                        </div>)
                    })
                }
                {
                    props.goalGroup.goals.length < 2 &&
                    <div className="col-12">
                        <Button name="goal-add" type="button" bootstrapClass="link goal-add" text="Add goal to this group" onClick={() => props.addGoalToGroup(props.goalGroup.ordinal)} />
                    </div>
                }
            </div>


        </Drawer>
    )        



}

SubscriptionGoalDrawer.propTypes = {
    goalGroup: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onGoalGroupChange: PropTypes.func.isRequired,
    onGoalChange: PropTypes.func.isRequired,
    addGoalToGroup: PropTypes.func.isRequired
};

export default SubscriptionGoalDrawer;

